import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'paginate', pure: false })
export class PaginatePipe implements PipeTransform {
  transform(data, options) {
    const {itemsPerPage, currentPage} = options;
    if (data.length > itemsPerPage) {
      const start = itemsPerPage * (currentPage - 1); // 10
      const end = start + itemsPerPage; // 20
      return data.slice(start, end);
    }
    return data;
  }
}
